import React from 'react';
import Sticky from 'react-stickynode';
import WebsitePreview from '../WebsitePreview';

const WebsitePreviewSticky: React.FC = () => (
  <Sticky enabled top={170.5} bottomBoundary="#sticky-preview-anchor">
    <WebsitePreview />
  </Sticky>
);
export default WebsitePreviewSticky;
